<template>
  <div>
    <t-form labelWidth="80px">
      <t-form-item label="图库选择">
        <div @click="showGallery" style="width: 40px; height: 40px">
          <t-image
            style="width: 100%; height: 100%; background: none"
            :src="
              attribute.url
                ? fileUrl + attribute.url
                : require('@/assets/scan.png')
            "
            fit="fill"
          />
        </div>
      </t-form-item>
      <t-form-item label="图片宽度">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="currentCpt.cptWidth"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="图片高度">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="currentCpt.cptHeight"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="填充方式">
        <t-select
          v-model="attribute.fit"
          placeholder="请选择填充方式"
          size="small"
        >
          <t-option label="fill" value="fill" />
          <t-option label="contain" value="contain" />
          <t-option label="cover" value="cover" />
          <t-option label="none" value="none" />
          <t-option label="scale-down" value="scale-down" />
        </t-select>
      </t-form-item>
      <t-form-item label="自动旋转">
        <t-radio-group v-model="attribute.autoRotate" size="small">
          <t-radio :value="true">开启</t-radio>
          <t-radio :value="false">关闭</t-radio>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="自旋时长(s)">
        <t-input-number
          :min="1"
          :max="60"
          v-model="attribute.rotateDuration"
          size="small"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          v-model="attribute.bgColor"
          enableAlpha
          size="small"
        />
      </t-form-item>
    </t-form>
    <gallery ref="gallery" @confirmCheck="confirmCheck" />
  </div>
</template>

<script>
import Gallery from "@/components/designer/gallery";
import { fileUrl } from "/env";
export default {
  name: "cpt-image-option",
  components: { Gallery },
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  data() {
    return {
      fileUrl,
    };
  },
  methods: {
    showGallery() {
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl) {
      this.attribute.url = fileUrl;
    },
  },
};
</script>

<style scoped>
</style>
